export const AIGuideActivityKind = "AIGuideActivity";
